export const networkCommon = {
  networkConnected: [],
  networkDisconnected: []
};

export function isNetworkEventSupported(event) {
  if (!networkCommon[event]) {
    throw new Error(
      // TODO consider moving this string to the errors file
      `The network manager doesn't support ${event} event notifications.`
    );
  }
  return true;
}

export function on(event, listener) {
  if (isNetworkEventSupported(event)) {
    networkCommon[event].push(listener);
  }
}

export function off(event, listener) {
  if (isNetworkEventSupported(event)) {
    const listenerIndex = networkCommon[event].findIndex(existingListener => existingListener === listener);
    networkCommon[event].splice(listenerIndex, 1);
  }
}

export const status = {
  DISCONNECTED: "disconnected",
  CONNECTED: "connected",
  CONNECTING: "connecting",
  OTHER: "other"
};
